module.exports = __webpack_public_path__ + "img/P1.e7efea06.jpg";